import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetWheelState, WheelSpin } from "./luckyWheel.api";
import { WheelSpinErrorMessages } from "./luckyWheel.error";
import { toast } from "react-toastify";

export const GetWheelStateThunk = createAsyncThunk(
  "LuckyWheel/GetWheelState",
  async (request: void, { rejectWithValue, dispatch, getState }) => {
    const { response, error } = await GetWheelState();

    if (error) {
      return rejectWithValue(error);
    }

    return response;
  }
);

export const WheelSpinThunk = createAsyncThunk(
  "LuckyWheel/WheelSpin",
  async (request: void, { rejectWithValue, dispatch, getState }) => {
    const { response, error } = await WheelSpin();

    if (error) {
      toast.info(WheelSpinErrorMessages[error]);
      return rejectWithValue(error);
    }

    return response;
  }
);
